// extracted by mini-css-extract-plugin
export default {"badgeicon":"BadgeIcon_badgeicon__qhgWP"};